module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/10-a84695997077a2f0e13f7485e7241cca.jpg";